import {FC, Suspense} from 'react';
import TopBarProgress from 'react-topbar-progress-indicator';
import {WithChildren, getCSSVariableValue} from '../helpers';

const SuspensedView: FC<WithChildren> = ({children}) => {
	const baseColor = getCSSVariableValue('--primary-color');
	TopBarProgress.config({
		barColors: {
			'0': baseColor,
		},
		barThickness: 1,
		shadowBlur: 5,
	});
	return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export default SuspensedView;
